import { render, staticRenderFns } from "./evaluateList.vue?vue&type=template&id=b81ed4e4&scoped=true"
import script from "./evaluateList.vue?vue&type=script&lang=js"
export * from "./evaluateList.vue?vue&type=script&lang=js"
import style0 from "./evaluateList.vue?vue&type=style&index=0&id=b81ed4e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81ed4e4",
  null
  
)

export default component.exports